import { NavbarDropdownType } from "@/lib/main";
import { NavbarDropdownDirectionType } from "@/lib/types/navigation/header/navbar/NavbarMenuItem.type";
import { RefObject } from "react";

type SideOpenDirectionInput = {
  availableLeft: number;
  availableRight: number;
  defaultOpenToRight: boolean;
  isLastItem: boolean;
  submenuWidth: number;
};

type SideLayoutType = {
  left: number | null;
  maxHeight: number;
  right: number | null;
  top: number;
};

type SideLayoutArgs = {
  anchorLeft: number;
  anchorRight: number;
  isLastItem: boolean;
  submenuWidth: number;
  textDirection: "ltr" | "rtl";
  top: number;
  viewportHeight: number;
  viewportWidth: number;
};

type NavbarMenuItemSubmenuProps = {
  anchorRef?: RefObject<HTMLLIElement | null>;
  direction: NavbarDropdownDirectionType;
  isHashLinks?: boolean;
  isHovered: boolean;
  isLastItem?: boolean;
  navbarMenuItem: NavbarDropdownType;
  onMouseEnter?: () => void;
  onMouseLeave?: () => void;
};

const initialSideLayout: SideLayoutType = {
  left: null,
  maxHeight: 0,
  right: null,
  top: 0,
};

export { initialSideLayout };
export type {
  NavbarMenuItemSubmenuProps,
  SideLayoutArgs,
  SideLayoutType,
  SideOpenDirectionInput,
};
